import { Product } from '@/common/interfaces';
import { CreativeTypeName } from '@/views/creatives/enums';
import { CreativeType } from '@/views/creatives/interfaces';

export const PLAY_PRODUCT: CreativeType = {
  id: 2,
  name: CreativeTypeName.PLAY,
  type: 'Interactive',
  isEnabled: true,
};

export const CANVAS_PRODUCT: CreativeType = {
  id: 1,
  name: CreativeTypeName.CANVAS,
  type: 'Static',
  isEnabled: true,
};

export const PRODUCTS_LIST: Product[] = [
  CANVAS_PRODUCT,
  PLAY_PRODUCT,
];

export default PRODUCTS_LIST;
